import Context from './Context';

export default Context.Consumer;
